<template>
  <div ref="images" class="usp-app-imgs" v-if="moduleData.topicTitle"><!-- :class="{ active: showAni }"-->
    <div class="usp-app-imgs-title h1-vw ani">{{moduleData.topicTitle}}</div>
    <div class="usp-app-imgs-title-desc h3-s-vw ani">{{moduleData.topicDes}}</div>
    <div class="usp-app-img-list">
      <div class="usp-app-img-list-left">
        <div class="ani delay-1">
          <!-- <img
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134528179-web_usp_0901@1x.jpg"
            alt
          /> -->
           <img
            :src="moduleData.jiugonggeGroupPic[0]"
            alt
          />
        </div>
      </div>
      <div class="usp-app-img-list-right">
        <div class="usp-app-img-list-right-top">
          <div class="ani delay-2">
            <!-- <img
              src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527619-web_usp_0902@1x.jpg"
              alt
            /> -->
             <img
            :src="moduleData.jiugonggeGroupPic[1]"
            alt
          />
          </div>
          <div class="ani delay-2">
            <!-- <img
              src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134530394-web_usp_0903@1x.jpg"
              alt
            /> -->
            <img
              :src="moduleData.jiugonggeGroupPic[2]"
              alt
            />
          </div>
        </div>
        <div class="usp-app-img-list-right-bottom">
          <div class="ani delay-3">
            <!-- <img
              src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527596-web_usp_0904@1x.jpg"
              alt
            /> -->
            <img
              :src="moduleData.jiugonggeGroupPic[3]"
              alt
            />
          </div>
          <div class="ani delay-4">
            <!-- <img
              src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527664-web_usp_0905@1x.jpg"
              alt
            /> -->
            <img
              :src="moduleData.jiugonggeGroupPic[4]"
              alt
            />
          </div>
          <div class="ani delay-5">
            <!-- <img
              src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210624134527984-web_usp_0906@1x.jpg"
              alt
            /> -->
            <img
              :src="moduleData.jiugonggeGroupPic[5]"
              alt
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
     name: "squaredImages",
     props:{
      moduleData:{
        type:Object
      }
     },
     data() {
      return{}
     }
}
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
@include setThemeClass {
    .usp-app-ctrl {
      position: relative;
      overflow: hidden;
      @include media(
        (
          $home-sm: (
            background-color: getThemeVal(brandColorWhite)
          )
        )
      );

      .usp-app-mask {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-image: linear-gradient(
          180deg,
          getThemeVal(brandColorBlackOpacity1) 0%,
          rgba(0, 0, 0, 0) 50%
        );
        z-index: 3;
      }
      .usp-app-ctrl-car-box {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 2;
        background: setBgImg(
          "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210625165040369-web_usp_05@1x.jpg",
          cover
        );
        @include media((
            $home-md: (
              background-image:url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630160124144-ipad_car@3x.png),
            ),
            $home-sm: (
              background-image:url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630160124129-phone_car@3x.png),
            ),
          )
        );
        .usp-app-ctrl-car {
          position: absolute;
          top: 30%;
          left: 50%;
          margin-left: vw(-725);
          width: vw(1454);
          height: vw(818);
          background: setBgImg(
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210625165040551-car007@3x.png",
            contain
          );
          @include media(
            (
              $home-md: (
                margin-left: -405px,
                width: 810px,
                height: 458px,
                top: 35%
              ),
              $home-sm: (
                margin-left: -188px,
                width: 375px,
                height: 211px,
                top: 50%
              )
            )
          );
          .usp-app-ctrl-car-run {
            position: absolute;
            width: vw(198);
            height: vw(198);
            background: setBgImg(
              "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210625165039906-before@3x.png",
              contain
            );
            @include media(
              (
                $home-md: (
                  width: 111px,
                  height: 111px
                ),
                $home-sm: (
                  width: 51px,
                  height: 51px
                )
              )
            );
          }
          .run1 {
            top: vw(402);
            left: vw(239);
            @include media(
              (
                $home-md: (
                  top: 227px,
                  left: 132px
                ),
                $home-sm: (
                  top: 105px,
                  left: 62px
                )
              )
            );
          }
          .run2 {
            top: vw(402);
            right: vw(255);
            @include media(
              (
                $home-md: (
                  top: 227px,
                  right: 139px
                ),
                $home-sm: (
                  top: 105px,
                  right: 65px
                )
              )
            );
          }
        }
      }
    }
    .usp-app-ctrl-bg-outer {
      position: relative;
    }
    .usp-app-ctrl-bg {
      .usp-app-ctrl-bg-img {
        width: 100%;
        height: auto;
      }
    }

    .usp-app-ctrl-title {
      position: relative;
      z-index: 3;
      margin-top: vw(100);
      padding: 0 20px;
      @include h1-s(getThemeVal(brandColorWhite), vw);
      @include media(
        (
          $home-md: (
            margin-top: 60px,
            font-size: 36px,
            line-height: 48px
          ),
          $home-sm: (
            margin-top: 40px,
            font-size: 28px,
            line-height: 42px
          )
        )
      );
    }
    .usp-app-ctrl-desc {
      position: relative;
      z-index: 3;
      margin-top: vw(20);
      padding: 0 20px;
      @include h3-s(getThemeVal(brandColorWhite), vw);
      @include media(
        (
          $home-md: (
            margin-top: 10px,
            font-size: 14px,
            line-height: 30px
          )
        )
      );
    }
    .usp-app-ctrl-top {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      overflow: hidden;
      text-align: center;
      z-index: 10;
    }
    .usp-app-ctrl-right {
      position: absolute;
      width: vw(900);
      right: 0;
      top: 0;
      bottom: 0;
      overflow: hidden;
      text-align: center;
      z-index: 10;
      background-color: getThemeVal(navColorBlackOpacity2);
      @include media(
        (
          $home-md: (
            width: 52%
          ),
          $home-sm: (
            width: 100%,
            background-color: transparent,
            position: relative,
            right: auto,
            top: auto,
            bottom: auto,
            padding-bottom: 40px
          )
        )
      );
      .usp-app-ctrl-phone {
        margin: 0 auto;
        margin-top: vw(60);
        width: vw(440);
        height: auto;
        display: block;
        @include media(
          (
            $home-md: (
              margin: 118px auto 0,
              width: 297px
            ),
            $home-sm: (
              margin-top: 324px
            )
          )
        );
        img {
          width: 100%;
          height: auto;
        }
      }
    }
    .ctrl1 {
      overflow: hidden;
      .usp-app-ctrl-bg-outer {
        @include media(
          (
            $home-sm: (
              position: absolute,
              top: 0,
              left: 0,
              right: 0,
              z-index: 1
            )
          )
        );
      }
    }
  }

</style>